import { FC, CSSProperties } from 'react';

type DataSourceEmptyStateIconProps = {
  style?: CSSProperties;
  className?: string;
};

export const DataSourceEmptyStateIcon: FC<DataSourceEmptyStateIconProps> = ({
  style,
  className,
}) => {
  return (
    <svg
      viewBox="0 0 124 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <rect x="6" y="0.5" width="112" height="112" rx="56" fill="white" />
      <path
        d="M75.2643 61.9715L56.5285 43.2358L75.2643 24.5L94 43.2358L75.2643 61.9715ZM30 55.3394V28.8109H56.5285V55.3394H30ZM63.1606 88.5V61.9715H89.6891V88.5H63.1606ZM30 88.5V61.9715H56.5285V88.5H30Z"
        fill="#B0E5EC"
      />
      <g opacity="0.25" filter="url(#filter0_f_255_38469)">
        <ellipse
          cx="62"
          cy="120.5"
          rx="56"
          ry="8"
          fill="url(#paint0_radial_255_38469)"
          fillOpacity="0.75"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_255_38469"
          x="0.240001"
          y="106.74"
          width="123.52"
          height="27.52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.88"
            result="effect1_foregroundBlur_255_38469"
          />
        </filter>
        <radialGradient
          id="paint0_radial_255_38469"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(62 120.5) scale(56 303.565)"
        >
          <stop stopColor="#B0BEC5" />
          <stop offset="1" stopColor="#B0BEC5" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};
